function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0.670372H61V61.6978H0V0.670372Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_64_250)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M28.1452 45.8014C28.1452 46.4813 29.5745 48.5398 30.499 48.5398C31.4236 48.5398 32.8529 46.4813 32.8529 45.8014M37.9295 33.5643V37.7353M46.9059 28.2784C44.0868 22.4263 39.5557 16.891 38.2415 16.2382M38.2415 16.2382C36.2899 15.2688 33.588 14.8508 30.499 14.8508C27.4101 14.8508 24.7082 15.2688 22.7565 16.2382M38.2415 16.2382L45.9672 3.07989M22.7565 16.2382C22.5125 16.3593 22.1577 16.6487 21.7237 17.0772M22.7565 16.2382L15.0308 3.07989M19.5488 19.5778C16.2173 23.8309 11.7603 31.1937 11.7603 36.495C11.7603 41.5993 17.2786 45.6348 21.5762 46.3615C22.6736 48.9911 24.5585 50.3353 27.1257 50.3353C28.3612 50.3353 30.499 49.7394 30.499 49.7394C30.499 49.7394 32.6368 50.3353 33.7174 50.3353C36.393 50.3353 38.3025 49.0434 39.4217 46.3615C43.7195 45.6348 49.2376 41.5993 49.2376 36.495C49.2376 35.0051 48.8856 33.3525 48.3055 31.6517M27.1501 50.4526C27.7619 53.5543 28.42 53.5519 30.499 53.5519C32.578 53.5519 33.236 53.5543 33.8479 50.4526M45.9672 3.07989C45.6839 3.57598 45.4543 4.3145 45.4543 4.96876V14.8494C45.4543 17.6173 44.3311 19.514 42.5795 20.7375M45.9672 3.07989C46.5203 2.11168 47.4748 1.56326 49.0597 1.56326C51.4756 1.56326 53.85 2.67821 55.6202 4.57697M50.5003 60.8027C47.8945 56.3402 42.7072 51.4348 38.0857 48.792M56.082 51.9542C51.8195 49.0501 44.9887 46.8339 39.6061 46.3766M22.9124 48.792C18.2909 51.4348 13.1035 56.3402 10.4977 60.8027M21.3919 46.3766C16.0094 46.8339 9.17857 49.0501 4.91596 51.9542M23.0686 33.5643V37.7353M15.0308 3.07989C14.4777 2.11168 13.5232 1.56326 11.9383 1.56326C7.10624 1.56326 2.44141 6.02303 2.44141 12.2937C2.44141 15.2845 3.37797 17.8657 5.07787 19.8605M15.0308 3.07989C15.3142 3.57598 15.5438 4.3145 15.5438 4.96876V14.8494C15.5438 17.6173 16.6668 19.514 18.4184 20.7375M57.5513 7.49519C58.1883 8.91253 58.5566 10.5316 58.5566 12.2937C58.5566 19.4104 53.2533 24.208 44.9818 24.3053M16.0162 24.3053C12.8329 24.2678 10.089 23.5342 7.91806 22.2401",
  stroke: "black",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

function SvgRodents(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 62,
    viewBox: "0 0 61 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_64_250",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 61,
    height: 62
  }, _ref2), _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRodents);
export default __webpack_public_path__ + "static/media/rodents.b9353d136574cdb67fc9db277ec6cef6.svg";
export { ForwardRef as ReactComponent };